import React, { forwardRef, useState, useContext } from "react";

import PivotTableUI from "react-pivottable/PivotTableUI";
import "react-pivottable/pivottable.css";

import { formatDataForPivotTable } from "components/Utils/ChartsDataUtils";
import { QueryBuilderContext } from "contexts/QueryBuilderContextProvider";

const QueryBuilderPivotTable = forwardRef((props, ref) => {
  const { state: globalState } = useContext(QueryBuilderContext);

  const [data, setData] = useState({
    data: formatDataForPivotTable(props.data, globalState.queryMetrics),
    hiddenAttributes: ["date"],
  });

  const el = document.getElementsByClassName("pvtAxisContainer")[2];

  if (data && data.rows && data.rows.length > 0) {
    el.classList.add("no-pseudo");
  } else {
    el && el.classList.remove("no-pseudo");
  }

  return <PivotTableUI ref={ref} onChange={(s) => setData(s)} {...data} />;
});

export default QueryBuilderPivotTable;
